'use memo';

import { AgxButton, AgxSpacer } from '@urbanx/agx.ui-components2';

interface TaskModalActionButtonsProps {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void | Promise<void>;
  onNext: () => void | Promise<void>;
  onComplete: () => void | Promise<void>;
  onSaveAndExit: () => void | Promise<void>;
  completeDisabled?: boolean;
  saveAndExitDisabled?: boolean;
  isSaving?: boolean;
  previousButtonText?: string;
}

const TaskModalActionButtons = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  onComplete,
  onSaveAndExit,
  completeDisabled = false,
  saveAndExitDisabled = false,
  isSaving = false,
  previousButtonText = 'Back',
}: TaskModalActionButtonsProps) => {
  const showPreviousButton = currentPage !== 0;
  const showNextButton = currentPage !== totalPages - 1;
  const showCompleteButton = currentPage === totalPages - 1;

  return (
    <AgxSpacer
      direction="horizontal"
      fill
      contentJustification="space-between"
      contentAlignment="center"
      gap="xs"
    >
      <AgxButton
        id={'complianceModal-saveAndExit'}
        text={'Save & Exit'}
        variant={'hollow'}
        size="large"
        onClick={onSaveAndExit}
        disabled={saveAndExitDisabled || isSaving}
      />
      <AgxSpacer
        direction="horizontal"
        gap="xs"
        contentJustification="end"
        contentAlignment="center"
      >
        {showPreviousButton && (
          <AgxButton
            id={'complianceModal-previous'}
            text={previousButtonText}
            variant={'hollow'}
            size="large"
            onClick={onPrevious}
            disabled={isSaving}
          />
        )}
        {showNextButton && (
          <AgxButton
            id={'complianceModal-next'}
            text={'Next'}
            variant={'primary'}
            size="large"
            onClick={onNext}
            disabled={isSaving}
          />
        )}
        {showCompleteButton && (
          <AgxButton
            id={'complianceModal-complete'}
            text={'Complete'}
            variant={'primary'}
            size="large"
            onClick={onComplete}
            disabled={completeDisabled || isSaving}
          />
        )}
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default TaskModalActionButtons;
